// GA4 remove_from_cart — fires when a basket line's Remove link is clicked.
// The link navigates (server-side RemoveFromCart), so we push the event first,
// then follow the link after a short delay to give the tag time to send.
(function () {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.js-remove-from-cart');
    if (!link || link.dataset.dlPushed === '1') return;

    e.preventDefault();
    link.dataset.dlPushed = '1';

    const price = parseFloat(link.dataset.gaPrice) || 0;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'custom_remove_from_cart',
      datalayer_event_name: 'remove_from_cart',
      ecommerce: {
        currency: 'GBP',
        value: price,
        items: [{
          item_id: link.dataset.gaItemId || '',
          item_name: link.dataset.gaItemName || '',
          price: price,
          quantity: parseInt(link.dataset.gaQuantity, 10) || 1,
        }],
      },
    });

    const href = link.getAttribute('href');
    setTimeout(function () { window.location.href = href; }, 250);
  });
})();
